import * as React from "react"
export const ReorderListIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    className="stroke-fg-2"
    viewBox="0 0 18 18"
    fill="none"
    {...props}>
    <g strokeLinecap="round" strokeWidth={1.417}>
      <path
        stroke="inherit"
        strokeLinejoin="round"
        d="M13.417 2.625v12.75m0-12.75L11.292 4.75m2.125-2.125 2.125 2.125m-2.125 10.625-2.125-2.125m2.125 2.125 2.125-2.125"
      />
      <path stroke="inherit" d="M2.792 4.75h1.417M2.792 9h3.542M2.792 13.25h5.667" />
    </g>
  </svg>
)
